import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import { Flyout } from '@els/els-react--flyout';
import { ButtonWithIcon } from '@els/els-react--button';

export function getClickHandler(spec) {
  const { item, isActive, setSorting, buttonOrderValue, isTgitemsContext } = spec;

  if (isActive) {
    return (e) => {
      e.preventDefault();
      e.stopPropagation();
    };
  }

  const nextValue = !isTgitemsContext ? item.get('value') : buttonOrderValue;

  return (e) => {
    e.preventDefault();
    e.stopPropagation();
    setSorting(nextValue, buttonOrderValue);
  };
}

function getLabel(buttonOrderValue) {
  switch (buttonOrderValue) {
    case 'asc':
      return 'Sort ascending';
    case 'desc':
      return 'Sort descending';
    default:
      Logger.warn('Unknown sort order value', buttonOrderValue);
      return `Sort ${buttonOrderValue}`;
  }
}

export default function OrderButton(props) {
  const { item, icon, order, setSorting, buttonOrderValue, isTgitemsContext, ...otherProps } = props;
  const isActive = buttonOrderValue === order;
  const clickHandler = getClickHandler({
    item,
    isActive,
    setSorting,
    isTgitemsContext,
    buttonOrderValue,
  });

  return (
    <Flyout
      flyout={getLabel(buttonOrderValue)}
      placement="top-end"
      trigger="hover"
      theme="minimal"
      inline
      className="result-toolbar-sort-by__order-button-flyout">
      <ButtonWithIcon
        type="link"
        sprite={icon}
        iconOnly
        linkIconSize="xs"
        disabled={isActive}
        onClick={clickHandler}
        className={classnames('result-toolbar-sort-by-order-button', { active: isActive }, 'e2e-order')}
        role="button"
        aria-label={getLabel(buttonOrderValue)}
        aria-pressed={isActive}
        data-e2e="sort-order-button"
        {...otherProps}>
        {getLabel(buttonOrderValue)}
      </ButtonWithIcon>
    </Flyout>
  );
}

OrderButton.propTypes = {
  item: PropTypes.instanceOf(Map).isRequired,
  icon: PropTypes.string.isRequired,
  order: PropTypes.string.isRequired,
  setSorting: PropTypes.func.isRequired,
  buttonOrderValue: PropTypes.string.isRequired,
  isTgitemsContext: PropTypes.bool.isRequired,
};
